<template>
  <div>
    <!-- 見出し -->
    <div
      id="cast_header_bar"
      class="pa-2 blue--text blue lighten-5 d-flex align-center"
    >
      <div class="big mr-4">{{ agency.name }}</div>
    </div>

    <app-bar
      ref="refAppBar"
      :agency_id="agencyIdNum"
      @on_back="onBack"
      @updated="updated"
    ></app-bar>

    <v-card elevation="0">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="（キーワード検索）"
          single-line
          hide-details
          clearable
          dense
        ></v-text-field>
      </v-card-title>
      <!-- テーブル -->
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        item-key="id"
        :mobile-breakpoint="0"
        :items-per-page="100"
        :footer-props="{
          'items-per-page-options': [100, 200, 400, -1],
          'items-per-page-text': '表示件数',
        }"
      >
        <!-- eslint-disable-next-line -->
        <template v-slot:footer.page-text="props">
          {{ props.pageStart }} ～{{ props.pageStop }}件／全{{
            props.itemsLength
          }}件
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.edit="{ item }">
          <v-icon class="pa-1" @click="editItem(item)"> mdi-pencil </v-icon>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.delete="{ item }">
          <v-icon class="pa-1" @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <template v-slot:no-data> 表示するデータがありません </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  toRefs,
  computed,
  defineComponent,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import { useRouter } from "@/utils";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import appBar from "./appBar.vue";

export default defineComponent({
  components: {
    appBar,
  },
  props: ["agency_id"],
  setup(props, ctx) {
    const { router } = useRouter();
    const agenciesRepository = repositoryFactory.get("agencies");
    const agencyContactsRepository = repositoryFactory.get("agencyContacts");
    const refAppBar = ref();
    const state = reactive({
      search: "",
      agency: {
        id: 0,
        name: "",
      },
      headers: [
        {
          text: "編集",
          value: "edit",
          sortable: false,
          align: "center",
          width: 60,
        },
        {
          text: "担当者名",
          value: "name",
          sortable: true,
          class: "td_name",
        },
        {
          text: "電話番号",
          value: "tel",
          sortable: true,
          class: "td_tel",
        },
        {
          text: "メールアドレス",
          value: "email",
          sortable: true,
          class: "td_email",
        },
        {
          text: "メモ",
          value: "note",
          sortable: true,
          class: "td_note",
        },
        {
          text: "削除",
          value: "delete",
          sortable: false,
          align: "center",
          width: 60,
        },
      ],
      desserts: [], // DataTablesレコード格納用
    });

    // paramsは文字列で来るので数値化
    const agencyIdNum = computed(() => Number(props.agency_id));

    const editItem = (item) => {
      refAppBar.value.action({
        action: "edit",
        value: item.id,
      });
    };

    // データ削除
    const deleteItem = async (item) => {
      if (window.confirm("削除してよろしいですか？")) {
        store.dispatch("loadingIcon/showIcon"); // ローディング表示

        // 削除処理
        await agencyContactsRepository
          .admin_delete(item.id)
          .then((response) => {
            if (response.data) {
              // データ削除OK
              alert(`「${item.name}」が削除されました。`);
            }
          })
          .catch((error) => {
            throw (
              "ERROR:admin/agencyContact/index.vue/deleteItem agencyContactsRepository.admin_delete (" +
              error +
              ")"
            );
          });

        init();

        store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
      }
    };

    // 初期化処理(同期処理)
    const init = async () => {
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      // 代理店情報を取得
      await agenciesRepository
        .admin_get(agencyIdNum.value)
        .then((response) => {
          if (response.data) {
            state.agency.id = response.data.id;
            state.agency.name = response.data.name;
          }
        })
        .catch((error) => {
          throw (
            "ERROR:admin/agencyContact/index.vue/init agenciesRepository.admin_get (" +
            error +
            ")"
          );
        });

      // 担当者一覧取得
      state.desserts.splice(0);
      await agencyContactsRepository
        .admin_list_by_agency(agencyIdNum.value)
        .then((response) => {
          if (response.data) {
            Object.keys(response.data).forEach(function (key) {
              state.desserts.push(response.data[key]);
            });
          }
        })
        .catch((error) => {
          throw (
            "ERROR:admin/agencyContact/index.vue/init agencyContactsRepository.admin_list_by_agency (" +
            error +
            ")"
          );
        });

      store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
    };

    init();

    const updated = () => {
      init();
    };

    const onBack = () => {
      router.back();
    };

    // 返却オブジェクト定義
    return {
      refAppBar,
      setting,
      agencyIdNum,
      ...toRefs(state),
      editItem,
      deleteItem,
      init,
      updated,
      onBack,
    };
  },
});
</script>
<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  padding: 0 6px !important;
}
::v-deep .td_name {
  min-width: 150px;
  width: 200px;
}
::v-deep .td_tel {
  min-width: 110px;
  width: 140px;
}
::v-deep .td_email {
  min-width: 180px;
  width: 250px;
}
::v-deep .td_note {
  min-width: 150px;
}
</style>
